import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { BaseEditComponent } from "../../core/common/base-component";
import { FormUtil } from "../../core/form.util";
import { ReferralsService } from "../referrals.service";
import {
  ReferralProgram,
  ReferralProgramRequest,
} from "../referrals.interfaces";
const alertify = require("alertify.js");
import { Title } from '@angular/platform-browser';

@Component({
  selector: "ch-programs-edit",
  templateUrl: "./programs-edit.component.html",
  styleUrls: ["./programs-edit.component.css"],
})
export class ReferralProgramsEditComponent
  extends BaseEditComponent
  implements OnInit, OnDestroy
{
  public referralProgramId: string;
  public referralProgramData: ReferralProgram = {
    id: "",
    name: "",
    createdAt: "",
    archivedAt: "",
    deletedAt: "",
  };
  public errors: any = {};
  public loading = false;
  public breadcrumb: string[] = ["Referral Programs"];

  constructor(
    private router: Router,
    private service: ReferralsService,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
  ) {
    super();
  }

  ngOnInit() {
    alertify.logPosition("bottom right");
    this.loadData();
  }

  ngOnDestroy() {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  public breadcrumbGoTo(data) {
    this.router.navigate(["/admin/referral-programs"]);
  }

  private loadData() {
    this.activatedRoute.queryParamMap
      .map((params: Params) => params.params)
      .subscribe((params) => {
        this.referralProgramId = params["id"];
        if (this.referralProgramId) {
          this.breadcrumb.push("Edit");
          this.loading = true;
          this.service.getReferralProgramById(this.referralProgramId).subscribe(
            (data) => {
              this.referralProgramData = data.json();
              this.titleService.setTitle(`${this.referralProgramData.name} | Referral Programs | CODE Hospitality CMS`);
              this.loading = false;
            },
            (error) => {
              this.loading = false;
              this.alertError(error);
              this.cancel();
            },
          );
        } else {
          this.breadcrumb.push("New");
          this.titleService.setTitle(`New Referral Program | CODE Hospitality CMS`);
        }
      });
  }

  public save(form) {
    if (!FormUtil.isValid(form)) {
      alertify.error("Please fill the fields correctly.");
      return;
    }

    const request: ReferralProgramRequest = {
      name: this.referralProgramData.name,
    };

    this.loading = true;
    if (this.referralProgramId) {
      this.service
        .updateReferralProgram(this.referralProgramId, request)
        .subscribe(
          (_) => {
            this.loading = false;
            this.cancel();
          },
          (err) => {
            this.loading = false;
            this.alertError(err);
          },
        );
    } else {
      this.service.createReferralProgram(request).subscribe(
        (_) => {
          this.loading = false;
          this.cancel();
        },
        (err) => {
          this.loading = false;
          this.alertError(err);
        },
      );
    }
  }

  public archive() {
    this.loading = true;
    this.service.archiveReferralProgram(this.referralProgramId).subscribe(
      (_) => {
        this.loading = false;
        this.cancel();
      },
      (err) => {
        this.loading = false;
        this.alertError(err);
      },
    );
  }

  public delete() {
    this.loading = true;
    this.service.deleteReferralProgram(this.referralProgramId).subscribe(
      (_) => {
        this.loading = false;
        this.cancel();
      },
      (err) => {
        this.loading = false;
        this.alertError(err);
      },
    );
  }

  public cancel() {
    this.router.navigateByUrl("/admin/referral-programs");
  }

  private alertError(error: any) {
    if (!error.error) {
      alertify.error(`There was a ${error.status} error with the request.`);
    } else {
      alertify.error(
        `There was a ${error.status} error with message '${error.error}'.`,
      );
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/referrals/programs/programs-edit.component.ts